function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useCallback, useContext } from 'react';
import styles from './MenuButton.module.scss';
import I18n from '../I18n/I18n/I18n';
import Button from '../Buttons/Button/Button';
import ButtonLabel from '../Buttons/ButtonLabel/ButtonLabel';
import Tooltip from '../Tips/Tooltip/Tooltip';
import cs from 'classnames';
import Caret from '../Icons/Caret/Caret';
import noop from '../utils/noop';
import Menu, { MenuContext } from '../Menu/Menu';
import MenuItem from '../Menu/MenuItem';
import ThemeContext from '../ThemeContext/ThemeContext';
function deprecationWarning(condition) {
  if (process.env.NODE_ENV !== 'production' && condition) {
    var _console;
    for (var _len = arguments.length, msg = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      msg[_key - 1] = arguments[_key];
    }
    (_console = console).warn.apply(_console, msg);
  }
}
function LegacyMenuItem(_ref) {
  var className = _ref.className,
    dangerouslySetInnerHTML = _ref.dangerouslySetInnerHTML,
    disabled = _ref.disabled,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? '' : _ref$label,
    onClick = _ref.onClick,
    PreIcon = _ref.PreIcon,
    props = _objectWithoutProperties(_ref, ["className", "dangerouslySetInnerHTML", "disabled", "label", "onClick", "PreIcon"]);
  // useCallback to make function identity stable across re-renders
  var closeMenu = useContext(MenuContext);
  var handleClick = useCallback(function () {
    if (disabled) {
      noop();
    } else {
      onClick && onClick();
      closeMenu && closeMenu();
    }
  }, [closeMenu, disabled, onClick]);
  return /*#__PURE__*/React.createElement(MenuItem, Object.assign({}, props, {
    disabled: disabled,
    onClick: handleClick,
    className: className
  }), PreIcon && /*#__PURE__*/React.createElement(PreIcon, {
    className: styles.icon
  }), /*#__PURE__*/React.createElement(I18n, {
    i18n: label,
    escape: !(dangerouslySetInnerHTML === true)
  }));
}
function LegacyButton(_ref2) {
  var buttonClassName = _ref2.buttonClassName,
    labelKey = _ref2.labelKey,
    _ref2$tooltipKey = _ref2.tooltipKey,
    tooltipKey = _ref2$tooltipKey === void 0 ? '' : _ref2$tooltipKey,
    expanded = _ref2.expanded,
    setRef = _ref2.setRef,
    _ref2$buttonProps = _ref2.buttonProps,
    className = _ref2$buttonProps.className,
    ref = _ref2$buttonProps.ref,
    _onBlur = _ref2$buttonProps.onBlur,
    props = _objectWithoutProperties(_ref2$buttonProps, ["className", "ref", "onBlur"]);
  var hideTooltip = expanded || !tooltipKey;
  var theme = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement(Tooltip, {
    i18nKey: tooltipKey,
    neverShow: hideTooltip
  }, function (_ref3) {
    var tooltipRef = _ref3.ref,
      describedby = _ref3.describedby,
      events = _ref3.events;
    return /*#__PURE__*/React.createElement(Button, Object.assign({
      className: cs(className, buttonClassName),
      "aria-describedby": describedby
    }, props, {
      ref: setRef(tooltipRef)
    }, events, {
      onBlur: function onBlur(e) {
        events.onBlur(e);
        _onBlur && _onBlur(e);
      }
    }), /*#__PURE__*/React.createElement(ButtonLabel, {
      i18nKey: labelKey
    }), /*#__PURE__*/React.createElement(Caret, {
      className: cs(styles.caret, styles[theme]),
      width: 13,
      height: 13
    }));
  });
}
export default function MenuButton(_ref4) {
  var _ref4$actions = _ref4.actions,
    actions = _ref4$actions === void 0 ? [] : _ref4$actions,
    buttonClassName = _ref4.buttonClassName,
    className = _ref4.className,
    tooltipKey = _ref4.tooltipKey,
    labelKey = _ref4.labelKey;
  deprecationWarning(true, '%c`Menu` warning: %cThe legacy APIs using `actions`, `tooltipKey`, and `labelKey` have been deprecated. Use `button` and `children` instead. See stories.', 'font-weight: bold', 'font-weight: normal');
  return /*#__PURE__*/React.createElement(Menu, {
    orientation: "right",
    className: cs(styles.menu, _defineProperty({}, String(className), className)),
    button: function button(_ref5) {
      var buttonProps = _ref5.buttonProps,
        setRef = _ref5.setRef,
        expanded = _ref5.expanded;
      return /*#__PURE__*/React.createElement(LegacyButton, {
        buttonProps: buttonProps,
        setRef: setRef,
        expanded: expanded,
        labelKey: labelKey,
        tooltipKey: tooltipKey,
        buttonClassName: buttonClassName
      });
    }
  }, actions.map(function (action) {
    return /*#__PURE__*/React.createElement(LegacyMenuItem, Object.assign({
      key: action.name
    }, action));
  }));
}